/* E3 HUD Tach — builds a scroll-progress tachometer around the Shopify Inbox
   "Message us" pill. The scale is the pill's own outline offset outward by a
   constant gap, so corner arcs are concentric with the pill's corners; the
   geometry is derived at runtime from the live widget's box, so a locale or
   Shopify size change re-proportions the gauge instead of breaking it.
   Redline (last 12.5%) = bottom of page. Partner stylesheet: e3-hud-tach.css.
   The widget cannot be restyled (closed styling surface inside an open shadow
   root); this element only overlays AROUND it and never intercepts clicks. */
(function () {
  'use strict';

  if (!document.querySelector('.e3-about-wrap') && !document.querySelector('[data-e3-hud-tach]')) return;

  var GAP = 9;            /* pill edge to band centerline */
  var BAND = 4;
  var TICK_IN = 5, TICK_MAJ = 10, TICK_MIN = 8, NUM_OFF = 16;
  var PAD_L = 32, PAD_T = 32, PAD_R = 20, PAD_B = 26;
  var RED_FRAC = 0.875;
  var WRAP_RAD = Math.PI / 4; /* scale end bends 45 deg around the far corner */
  /* Fallbacks = values measured on the live widget 2026-09-17. */
  var FB = { w: 147, h: 50, r: 12.3, right: 20, bottom: 80 };

  var host, svg, bandEl, headEl, pctEl, secEl, bandLen = 0, geo = null;
  var sections = [];
  var lastP = -1, ticking = false;

  function findActivator() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return null;
    var btn = chat.shadowRoot.querySelector('button.activator');
    if (!btn) return null;
    var rect = btn.getBoundingClientRect();
    if (rect.width < 20) return null;
    var wrap = btn.closest('.activator-nudge') || btn.parentElement;
    var ws = getComputedStyle(wrap);
    return {
      w: rect.width, h: rect.height,
      r: parseFloat(getComputedStyle(btn).borderRadius) || FB.r,
      right: parseFloat(ws.right) || FB.right,
      bottom: parseFloat(ws.bottom) || FB.bottom
    };
  }

  /* Piecewise walk along the band centerline: up the left side, around the
     top-left corner, across the top, 45 deg around the top-right corner. */
  function makeGeo(p) {
    var Rb = p.r + GAP;
    var x0 = PAD_L, y0 = PAD_T;
    var c1 = { x: x0 + p.r, y: y0 + p.r };
    var c2 = { x: x0 + p.w - p.r, y: y0 + p.r };
    var L1 = p.h - p.r, L2 = Rb * Math.PI / 2, L3 = p.w - 2 * p.r, L4 = Rb * WRAP_RAD;
    var T = L1 + L2 + L3 + L4;
    function at(s) {
      if (s <= L1) return { x: x0 - GAP, y: y0 + p.h - s, nx: -1, ny: 0 };
      if (s <= L1 + L2) {
        var a = Math.PI + (s - L1) / L2 * (Math.PI / 2);
        return { x: c1.x + Rb * Math.cos(a), y: c1.y + Rb * Math.sin(a), nx: Math.cos(a), ny: Math.sin(a) };
      }
      if (s <= L1 + L2 + L3) return { x: c1.x + (s - L1 - L2), y: y0 - GAP, nx: 0, ny: -1 };
      var b = 1.5 * Math.PI + (s - L1 - L2 - L3) / L4 * WRAP_RAD;
      return { x: c2.x + Rb * Math.cos(b), y: c2.y + Rb * Math.sin(b), nx: Math.cos(b), ny: Math.sin(b) };
    }
    var end = at(T);
    var d = 'M ' + (x0 - GAP) + ' ' + (y0 + p.h) +
            ' L ' + (x0 - GAP) + ' ' + c1.y +
            ' A ' + Rb + ' ' + Rb + ' 0 0 1 ' + c1.x + ' ' + (y0 - GAP) +
            ' L ' + c2.x + ' ' + (y0 - GAP) +
            ' A ' + Rb + ' ' + Rb + ' 0 0 1 ' + r2(end.x) + ' ' + r2(end.y);
    var sRed = RED_FRAC * T;
    var redStart = at(sRed);
    var dRed = 'M ' + r2(redStart.x) + ' ' + r2(redStart.y) +
               ' L ' + c2.x + ' ' + (y0 - GAP) +
               ' A ' + Rb + ' ' + Rb + ' 0 0 1 ' + r2(end.x) + ' ' + r2(end.y);
    return {
      p: p, T: T, at: at, d: d, dRed: dRed, sRed: sRed,
      svgW: PAD_L + p.w + PAD_R, svgH: PAD_T + p.h + PAD_B
    };
  }

  function r2(n) { return Math.round(n * 100) / 100; }

  function seg(from, to) { return 'M ' + r2(from.x) + ' ' + r2(from.y) + ' L ' + r2(to.x) + ' ' + r2(to.y); }
  function off(pt, dist) { return { x: pt.x + pt.nx * dist, y: pt.y + pt.ny * dist }; }

  function buildSvg(g) {
    var NS = 'http://www.w3.org/2000/svg';
    var el = document.createElementNS(NS, 'svg');
    el.setAttribute('class', 'e3-hud-tach__svg');
    el.setAttribute('width', g.svgW);
    el.setAttribute('height', g.svgH);
    el.setAttribute('viewBox', '0 0 ' + g.svgW + ' ' + g.svgH);
    el.setAttribute('aria-hidden', 'true');

    var defs = document.createElementNS(NS, 'defs');
    var grad = document.createElementNS(NS, 'linearGradient');
    grad.setAttribute('id', 'e3-hud-tach-grad');
    grad.setAttribute('x1', '0'); grad.setAttribute('y1', '1');
    grad.setAttribute('x2', '1'); grad.setAttribute('y2', '0');
    [['0', 'e3-hud-tach__grad-a'], ['0.65', 'e3-hud-tach__grad-b'], ['1', 'e3-hud-tach__grad-c']].forEach(function (s) {
      var stop = document.createElementNS(NS, 'stop');
      stop.setAttribute('offset', s[0]);
      stop.setAttribute('class', s[1]);
      grad.appendChild(stop);
    });
    defs.appendChild(grad);
    el.appendChild(defs);

    var minor = [], minorRed = [], major = [], majorRed = [], step = g.T / 8;
    for (var i = 0; i < 8; i++) {
      for (var j = 1; j < 4; j++) {
        var s = (i + j / 4) * step, pt = g.at(s);
        (s >= g.sRed ? minorRed : minor).push(seg(off(pt, TICK_IN), off(pt, TICK_MIN)));
      }
    }
    for (var k = 0; k < 9; k++) {
      var sk = k * step, pk = g.at(sk);
      (sk >= g.sRed - 0.5 ? majorRed : major).push(seg(off(pk, TICK_IN), off(pk, TICK_MAJ)));
    }
    path(el, minor.join(' '), 'e3-hud-tach__tick', 0.8);
    path(el, minorRed.join(' '), 'e3-hud-tach__tick--red', 0.8);
    path(el, major.join(' '), 'e3-hud-tach__tick--maj', 1);
    path(el, majorRed.join(' '), 'e3-hud-tach__tick--red', 1);

    path(el, g.d, 'e3-hud-tach__band-bg', BAND);
    path(el, g.dRed, 'e3-hud-tach__band-red', BAND);
    bandEl = path(el, g.d, 'e3-hud-tach__band', BAND);
    bandEl.setAttribute('stroke', 'url(#e3-hud-tach-grad)');
    bandEl.setAttribute('stroke-linecap', 'round');
    bandLen = bandEl.getTotalLength();
    bandEl.setAttribute('stroke-dasharray', '0 ' + (bandLen + 10));

    headEl = document.createElementNS(NS, 'circle');
    headEl.setAttribute('class', 'e3-hud-tach__head');
    headEl.setAttribute('r', '2.4');
    el.appendChild(headEl);

    for (var n = 0; n <= 8; n++) {
      var sn = n * step, pn = off(g.at(sn), NUM_OFF);
      var t = document.createElementNS(NS, 'text');
      t.setAttribute('class', 'e3-hud-tach__num' + (sn >= g.sRed - 0.5 ? ' e3-hud-tach__num--red' : ''));
      t.setAttribute('x', r2(pn.x)); t.setAttribute('y', r2(pn.y));
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('dominant-baseline', 'central');
      t.textContent = String(n);
      el.appendChild(t);
    }
    return el;
  }

  function path(parent, d, cls, w) {
    if (!d) return null;
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', d);
    p.setAttribute('class', cls);
    p.setAttribute('fill', 'none');
    p.setAttribute('stroke-width', w);
    parent.appendChild(p);
    return p;
  }

  /* Section titles: the About page's .sec-hd headers, or a blog post's
     numbered .e3-section-header blocks. No headers = gauge and % only. */
  function collectSections() {
    sections = [];
    var heads = document.querySelectorAll('.e3-about-wrap .sec-hd, [data-e3-hud-tach] .e3-section-header');
    for (var i = 0; i < heads.length; i++) {
      var num = heads[i].querySelector('.sec-num, .e3-section-num');
      var label = heads[i].querySelector('.sec-label, .e3-section-label');
      if (label) sections.push({ el: heads[i], txt: (num ? num.textContent.trim() + ' · ' : '') + label.textContent.trim() });
    }
  }

  function currentSection() {
    if (!sections.length) return '';
    var line = window.scrollY + window.innerHeight * 0.35, cur = sections[0].txt;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].el.getBoundingClientRect().top + window.scrollY <= line) cur = sections[i].txt;
    }
    return cur;
  }

  function render() {
    ticking = false;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    if (p === lastP) return;
    lastP = p;
    bandEl.setAttribute('stroke-dasharray', (p * bandLen) + ' ' + (bandLen + 10));
    var head = geo.at(p * geo.T);
    headEl.setAttribute('cx', r2(head.x));
    headEl.setAttribute('cy', r2(head.y));
    pctEl.textContent = Math.round(p * 100) + '%';
    if (secEl) secEl.textContent = currentSection();
    host.classList.toggle('is-on', p > 0.02);
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(render); }
  }

  function build(pill, standalone) {
    geo = makeGeo(pill);
    host = document.createElement('aside');
    host.id = 'e3-hud-tach';
    host.className = 'e3-hud-tach';
    host.setAttribute('aria-hidden', 'true');
    host.style.right = (pill.right - PAD_R) + 'px';
    host.style.bottom = (pill.bottom - PAD_B) + 'px';
    host.style.width = geo.svgW + 'px';
    host.style.height = geo.svgH + 'px';
    var veil = document.createElement('div');
    veil.className = 'e3-hud-tach__veil';
    host.appendChild(veil);
    host.appendChild(buildSvg(geo));

    var read = document.createElement('div');
    read.className = 'e3-hud-tach__readout';
    /* The % box is centered on the band's start tip (x = PAD_L - GAP); the
       section title shares its baseline and starts at the pill's left edge
       plus its corner radius, mirroring the top row's rhythm. */
    var pctBoxW = 2 * (PAD_L - GAP);
    read.style.left = '0px';
    read.style.top = (PAD_T + pill.h + 7) + 'px';
    pctEl = document.createElement('span');
    pctEl.className = 'e3-hud-tach__pct';
    pctEl.style.width = pctBoxW + 'px';
    read.appendChild(pctEl);
    secEl = document.createElement('span');
    secEl.className = 'e3-hud-tach__sec';
    secEl.style.marginLeft = (PAD_L + pill.r - pctBoxW) + 'px';
    /* Long titles (blog H2s) stop 6px short of the screen edge with an ellipsis. */
    secEl.style.maxWidth = (pill.w - pill.r + PAD_R - 6) + 'px';
    read.appendChild(secEl);
    host.appendChild(read);

    if (standalone) {
      var solo = document.createElement('div');
      solo.className = 'e3-hud-tach__solo';
      solo.style.left = PAD_L + 'px';
      solo.style.top = PAD_T + 'px';
      solo.style.width = pill.w + 'px';
      solo.style.height = pill.h + 'px';
      solo.style.borderRadius = pill.r + 'px';
      solo.innerHTML = '<span class="e3-hud-tach__solo-n"></span><span class="e3-hud-tach__solo-u">SCROLL</span>';
      host.appendChild(solo);
      pctEl = solo.querySelector('.e3-hud-tach__solo-n');
    }

    document.body.appendChild(host);
    collectSections();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    render();
  }

  /* The chat widget hydrates late; poll briefly, then fall back to standalone. */
  var tries = 0;
  var poll = setInterval(function () {
    var pill = findActivator();
    tries++;
    if (pill) {
      clearInterval(poll);
      build(pill, false);
    } else if (tries >= 16) {
      clearInterval(poll);
      build({ w: FB.w, h: FB.h, r: FB.r, right: FB.right, bottom: FB.bottom }, true);
    }
  }, 500);
})();
